import { useLocation } from "react-router-dom"
import { handleButtonws } from "../utils/utils"

export default function ButtonWs() {
    const pathname = useLocation().pathname
    const unassignedPaths = ["/home", "/settings", "/login", "/login/offer"]

    return (
        <button
            onClick={() => handleButtonws({ buttonWsPhone: '+573213368163', messageWs: 'Hola Soporte Fluxi, necesito ayuda con mi Fluxi' })}
            className={`w-16 h-16 px-2 py-2 rounded-full fixed bottom-6 ${unassignedPaths.includes(pathname) ? 'right-[80px]' : 'right-[19px]'} z-50`}
        >
            <div className="flex items-center justify-center gap-2">
                {unassignedPaths.includes(pathname) && (
                    <div className="text-gray-700 text-sm shadow-md w-40 bg-white text-center rounded-2xl px-4 py-2">
                        ¿Preguntas?
                    </div>
                )}
                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png" alt="WhatsApp" className="w-full h-full" />
            </div>
        </button>
    )
}